module.exports = __webpack_public_path__ + "img/grand-cancun-hotel-6.8398e4d9.jpg";